export function getSectionScores(answers) {
  const pain =
    (answers.q1?.score || 0) +
    (answers.q2?.score || 0) +
    (answers.q3?.score || 0);
  const familiarity =
    (answers.q4?.score || 0) +
    (answers.q5?.score || 0) +
    (answers.q6?.score || 0);
  const clarity =
    (answers.q7?.score || 0) +
    (answers.q8?.score || 0) +
    (answers.q9?.score || 0);
  const readiness = (answers.q13?.score || 0) + (answers.q14?.score || 0);
  const q8Score = answers.q8?.score || 0;
  const total = pain + familiarity + clarity + readiness;

  return { pain, familiarity, clarity, readiness, q8Score, total };
}

// maxScore: 12 for pain/familiarity/clarity, 8 for readiness
export function getLevel(sectionScore, maxScore = 12) {
  if (maxScore === 8) {
    if (sectionScore <= 3) return "developing";
    if (sectionScore <= 5) return "moderate";
    return "strong";
  }
  if (sectionScore <= 5) return "developing";
  if (sectionScore <= 8) return "moderate";
  return "strong";
}

export function getOverallLevel(totalScore) {
  if (totalScore <= 19) return "developing";
  if (totalScore <= 30) return "moderate";
  return "strong";
}
